<!-- eslint-disable vue/valid-v-slot -->
<template>
  <v-dialog :value="value" @input="$emit('input', $event)" fullscreen persistent scrollable>
    <v-card>
      <v-card-title class="px-4 pt-4 gap-2 elevation-5" style="z-index: 10">
        Schedule
        <v-spacer></v-spacer>
        <v-btn
          depressed
          class="text-capitalize"
          @click="onRemove"
          :disabled="itemsData[tab] === 'Results' ? !selectedResults.length : !selectedUpcoming.length"
          >Remove</v-btn
        >
        <v-btn color="primary" depressed class="text-capitalize" @click="onAdd">Add Event</v-btn>
      </v-card-title>
      <v-card-text class="pa-0">
        <v-tabs v-model="tab" grow class="px-4 pt-4">
          <v-tabs-slider color="primary"></v-tabs-slider>
          <v-tab v-for="item in itemsData" :key="item">
            {{ item }}
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab" class="px-4">
          <v-card flat>
            <div class="pt-0 my-4 d-flex flex-column gap-4">
              <!-- Results TABLE -->
              <v-data-table
                v-if="itemsData[tab] === 'Results'"
                class="schedule-table"
                disable-sort
                disable-filtering
                disable-pagination
                hide-default-footer
                :headers="headersResults"
                :items="itemsResults"
                item-key="resultId"
                v-model="selectedResults"
                show-select
              >
                <template #item.opponentLogo="props">
                  <div class="py-4">
                    <opponent-logo-img v-model="props.item.opponentLogo" :altText="props.item.opponentAltText" />
                  </div>
                </template>
                <template #item.opponent="props">
                  <div class="py-4">
                    <text-input-dialog
                      v-model="props.item.opponent"
                      :id="`opponent-${props.item.resultId}`"
                      :nextElementId="`location-${props.item.resultId}`"
                      :prevElementId="`result-${props.item.resultId - 1}`"
                    />
                  </div>
                </template>
                <template #item.location="props">
                  <div class="py-4">
                    <text-input-dialog
                      v-model="props.item.location"
                      :id="`location-${props.item.resultId}`"
                      :prevElementId="`opponent-${props.item.resultId}`"
                      :nextElementId="`stadium-${props.item.resultId}`"
                    />
                  </div>
                </template>
                <template #item.stadiumName="props">
                  <div class="py-4">
                    <text-input-dialog
                      v-model="props.item.stadiumName"
                      :id="`stadium-${props.item.resultId}`"
                      :prevElementId="`location-${props.item.resultId}`"
                      :nextElementId="`indicator-${props.item.resultId}`"
                    />
                  </div>
                </template>
                <template #item.locationIndicator="props">
                  <div class="pt-4">
                    <Indicator
                      v-model="props.item.locationIndicator"
                      :id="`indicator-${props.item.resultId}`"
                      :prevElementId="`stadium-${props.item.resultId}`"
                      :nextElementId="`date-${props.item.resultId}`"
                      dense
                    />
                  </div>
                </template>
                <template #item.date="props">
                  <div class="pt-4">
                    <DateInput
                      v-model="props.item.date"
                      :id="`date-${props.item.resultId}`"
                      :prevElementId="`indicator-${props.item.resultId}`"
                      :nextElementId="`time-${props.item.resultId}`"
                    />
                  </div>
                </template>
                <template #item.time="props">
                  <div class="py-4">
                    <time-input
                      v-model="props.item.time"
                      :id="`time-${props.item.resultId}`"
                      :prevElementId="`date-${props.item.resultId}`"
                      :nextElementId="`result-${props.item.resultId + 1}`"
                    />
                  </div>
                </template>
                <template #item.result="props">
                  <div class="py-4">
                    <text-input-dialog
                      v-model="props.item.result"
                      :id="`result-${props.item.resultId}`"
                      :prevElementId="`time-${props.item.resultId}`"
                      :nextElementId="`opponent-${props.item.resultId + 1}`"
                    />
                  </div>
                </template>
              </v-data-table>

              <!-- Upcoming Evetns TABLE -->
              <v-data-table
                v-if="itemsData[tab] === 'Upcoming Events'"
                class="schedule-table"
                disable-sort
                disable-filtering
                disable-pagination
                hide-default-footer
                :headers="headersUpcoming"
                :items="itemsUpcoming"
                item-key="upcomingId"
                v-model="selectedUpcoming"
                show-select
              >
                <template #item.opponentLogo="props">
                  <div class="py-4">
                    <opponent-logo-img v-model="props.item.opponentLogo" :altText="props.item.opponentAltText" />
                  </div>
                </template>
                <template #item.opponent="props">
                  <div class="py-4">
                    <text-input-dialog
                      v-model="props.item.opponent"
                      :id="`opponent-${props.item.upcomingId}`"
                      :prevElementId="`time-${props.item.upcomingId - 1}`"
                      :nextElementId="`location-${props.item.upcomingId}`"
                    />
                  </div>
                </template>
                <template #item.location="props">
                  <div class="py-4">
                    <text-input-dialog
                      v-model="props.item.location"
                      :id="`location-${props.item.upcomingId}`"
                      :prevElementId="`opponent-${props.item.upcomingId}`"
                      :nextElementId="`stadium-${props.item.upcomingId}`"
                    />
                  </div>
                </template>
                <template #item.stadiumName="props">
                  <div class="py-4">
                    <text-input-dialog
                      v-model="props.item.stadiumName"
                      :id="`stadium-${props.item.upcomingId}`"
                      :prevElementId="`location-${props.item.upcomingId}`"
                      :nextElementId="`indicator-${props.item.upcomingId}`"
                    />
                  </div>
                </template>
                <template #item.locationIndicator="props">
                  <div class="pt-4">
                    <Indicator
                      v-model="props.item.locationIndicator"
                      :id="`indicator-${props.item.upcomingId}`"
                      :prevElementId="`stadium-${props.item.upcomingId}`"
                      :nextElementId="`date-${props.item.upcomingId}`"
                      dense
                    />
                  </div>
                </template>
                <template #item.date="props">
                  <div class="pt-4">
                    <DateInput
                      v-model="props.item.date"
                      :id="`date-${props.item.upcomingId}`"
                      :prevElementId="`indicator-${props.item.upcomingId}`"
                      :nextElementId="`time-${props.item.upcomingId}`"
                    />
                  </div>
                </template>
                <template #item.time="props">
                  <div class="py-4">
                    <time-input
                      v-model="props.item.time"
                      :id="`time-${props.item.upcomingId}`"
                      :prevElementId="`date-${props.item.upcomingId}`"
                      :nextElementId="`opponent-${props.item.upcomingId + 1}`"
                    />
                  </div>
                </template>
              </v-data-table>
            </div>
          </v-card>
        </v-tabs-items>
      </v-card-text>

      <v-card-actions class="pa-4 elevation-5" style="z-index: 10">
        <v-spacer></v-spacer>
        <v-btn class="text-capitalize" depressed color="primary" @click="onSave">Done</v-btn>
        <v-btn class="text-capitalize" text @click="close">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script lang="ts">
  import Vue, { PropType } from 'vue';
  import { cloneDeep, sortBy, uniqueId } from 'lodash-es';
  import { mixins } from '../../mixin/mixins';
  import { ScheduleEvents, ScheduleBlockData } from '@/store/client/types';
  import { DateTime } from 'luxon';
  import DateInput from './ScheduleFields/DateInput.vue';
  import Indicator from './ScheduleFields/Indicator.vue';
  import TextInputDialog from './ScheduleFields/TextInputDialog.vue';
  import OpponentLogoImg from './ScheduleFields/OpponentLogoImg.vue';
  import TimeInput from './ScheduleFields/TimeInput.vue';

  export default Vue.extend({
    name: 'ScheduleBulkEditModal',
    mixins: [mixins],
    components: { DateInput, TimeInput, Indicator, TextInputDialog, OpponentLogoImg },
    props: {
      value: {
        type: Boolean,
        required: true,
      },
      data: {
        type: Object as PropType<ScheduleBlockData>,
        required: true,
      },
    },
    data() {
      return {
        dateFormat: 'M/d/yy',
        headersResults: [
          { text: 'Opponent Logo', value: 'opponentLogo' },
          { text: 'Opponent Name', value: 'opponent' },
          { text: 'Location', value: 'location' },
          { text: 'Stadium Name', value: 'stadiumName' },
          { text: 'Indicator', value: 'locationIndicator' },
          { text: 'Date', value: 'date' },
          { text: 'Time', value: 'time' },
          { text: 'Result', value: 'result' },
        ],
        headersUpcoming: [
          { text: 'Opponent Logo', value: 'opponentLogo' },
          { text: 'Opponent Name', value: 'opponent' },
          { text: 'Location', value: 'location' },
          { text: 'Stadium Name', value: 'stadiumName' },
          { text: 'Indicator', value: 'locationIndicator' },
          { text: 'Date', value: 'date' },
          { text: 'Time', value: 'time' },
        ],
        tab: null,
        itemsData: ['Upcoming Events', 'Results'],
        itemsResults: [] as ScheduleEvents[],
        itemsUpcoming: [] as ScheduleEvents[],
        selectedResults: [] as ScheduleEvents[],
        selectedUpcoming: [] as ScheduleEvents[],
      };
    },
    methods: {
      genId(): number {
        let id = parseInt(uniqueId());
        if (this.itemsData[this.tab] === 'Results') {
          while (this.itemsResults.some((item) => item.resultId === id)) {
            id = parseInt(uniqueId());
          }
          return id;
        } else {
          while (this.itemsUpcoming.some((item) => item.upcomingId === id)) {
            id = parseInt(uniqueId());
          }
          return id;
        }
      },
      onAdd() {
        if (this.itemsData[this.tab] === 'Results') {
          this.itemsResults.push({
            resultId: this.genId(),
            opponent: null,
            location: null,
            stadiumName: null,
            locationIndicator: null,
            opponentLogo: null,
            date: null,
            time: null,
            result: null,
            gameId: '',
          });
        } else {
          this.itemsUpcoming.push({
            upcomingId: this.genId(),
            opponent: null,
            location: null,
            stadiumName: null,
            locationIndicator: null,
            opponentLogo: null,
            date: null,
            time: null,
            gameId: '',
          });
        }
      },
      onRemove() {
        if (this.itemsData[this.tab] === 'Results') {
          const idsToRemove = this.selectedResults.map((item) => {
            return item.resultId;
          });
          this.itemsResults = this.itemsResults.filter((item) => {
            return !idsToRemove.includes(item.resultId);
          });
          this.selectedResults = [];
        } else {
          const idsToRemove = this.selectedUpcoming.map((item) => item.upcomingId);
          this.itemsUpcoming = this.itemsUpcoming.filter((item) => !idsToRemove.includes(item.upcomingId));
          this.selectedUpcoming = [];
        }
      },
      onSave() {
        if (!this.validateRows()) return;

        this.$emit('submit', {
          ...this.data,
          results: this.itemsResults,
          upcoming: this.itemsUpcoming,
        } as ScheduleBlockData);
        this.close();
      },
      validateRows() {
        for (let item of this.itemsUpcoming) {
          if (!item.date) {
            return false;
          }
        }

        for (let item of this.itemsResults) {
          if (!item.date) {
            return false;
          }
        }

        return true;
      },
      close() {
        this.$emit('input', false);
      },
    },
    watch: {
      value(visible: boolean) {
        if (visible) {
          this.itemsResults = sortBy(cloneDeep(this.data.results), ['date']).map((ele) => {
            return {
              ...ele,
              date: DateTime.fromISO(ele.date).toFormat('yyyy-MM-dd'),
              menuDate: false,
              resultId: this.genId(),
            };
          });
          this.itemsUpcoming = sortBy(cloneDeep(this.data.upcoming), ['date']).map((ele) => {
            return {
              ...ele,
              date: DateTime.fromISO(ele.date).toFormat('yyyy-MM-dd'),
              menuDate: false,
              upcomingId: this.genId(),
            };
          });
        }
      },
    },
  });
</script>
<style lang="scss">
  .cell-truncate {
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    min-height: 1.5rem;
  }

  .schedule-table {
    .custom-cell {
      max-width: 100px;

      .v-small-dialog__activator {
        @extend .cell-truncate;

        .v-small-dialog__activator__content {
          @extend .cell-truncate;
          display: block;
        }
      }
    }
  }
</style>
